export default __webpack_public_path__ + "static/simon-a9cee75a4fcaea837d199e1c1b065c2b.webp";